import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../helpers";

export const mainApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getChatList: builder.query({
      query: ({}) => ({
        url: `${END_POINTS.chatList}`,
        method: "GET",
      }),
    }),
    getChatHistory: builder.query({
      query: (session) => ({
        url: `${END_POINTS.chatHistory}${session}/`,
        method: "GET",
      }),
    }),

    dashboardData: builder.query({
      query: () => ({
        url: `${END_POINTS.dashboard}`,
        method: "GET",
      }),
    }),

    orderGraph: builder.mutation({
      query: (body) => ({
        url: `${END_POINTS.orderGraph}`,
        method: "POST",
        body,
      }),
    }),

    revenueGraph: builder.mutation({
      query: (body) => ({
        url: `${END_POINTS.revenueGraph}`,
        method: "POST",
        body,
      }),
    }),

    bestSelling: builder.mutation({
      query: ({ body }) => ({
        url: `${END_POINTS.bestSellingGraph}`,
        method: "GET",
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetChatListQuery,
  useLazyGetChatHistoryQuery,
  useLazyDashboardDataQuery,
  useOrderGraphMutation,
  useRevenueGraphMutation,
  useBestSellingMutation,
} = mainApi;
